import React, { useState } from 'react';
import {
  Button,
  Bubble,
  notification,
} from 'tea-component';

import SvgIcon from '@/pages/home/components/SvgIcon';
import AssociationModel from './associationModel';
import type { INumberPackage } from '@dbl/services/numberPackage';
import {useDblIntl} from "@/pages/datalab/utils/utils";
import type { IGetTableInfoDto } from '@dbl/services/dataSource';
export default function PacketSelect(props: any) {
  const {
    gameCode,
    namespace,
    userPackages,
    dataTables,
  }: {
    gameCode: string;
    namespace: string;
    userPackages: INumberPackage[];
    dataTables: IGetTableInfoDto[];
  } = props;

  // 两个hover变量
  const [isHover, setIsHover] = useState(false);
  // 关联号码包
  const [visible, setVisible] = useState(false);

  const { dblFormatMessage, commonFormatMessage } = useDblIntl("multi");

  return (
    <>
      <div className="left-title">
        <span className="left-title-text">{dblFormatMessage("number_package")}</span>
        <Bubble
          placement="right"
          dark
          content={dblFormatMessage("number_package_info")}
        >
          <i
            className="left-title-icon"
            onMouseMove={() => {
              setIsHover(true);
            }}
            onMouseOut={() => {
              setIsHover(false);
            }}
          >
            <SvgIcon type={isHover ? 'alert-circle-action' : 'alert-circle-m'} className="left-title-icon" />
          </i>
        </Bubble>
      </div>
      <div className="left-btn">
        <Bubble
          dark
          content={props?.pageConfig?.numberPackage?.disabled ? commonFormatMessage("no_access") : undefined}
        >
          <Button
            className="left-btn-text"
            onClick={() => {
              setVisible(true);
            }}
            disabled={props?.pageConfig?.numberPackage?.disabled}
          >
            {userPackages?.[0]?.name ?? dblFormatMessage("related_number_package")}
          </Button>
        </Bubble>
      </div>
      <AssociationModel
        gameCode={gameCode}
        userPackages={userPackages}
        dataTables={dataTables}
        visible={visible}
        close={() => {
          setVisible(false);
        }}
        getSuccess={(selectPacket: INumberPackage, selectTableFields: any[]) => {
          const packaged = {
            ...selectPacket,
            relate_column: Object.values(selectTableFields)
          };
          props.dispatch({
            type: `${namespace}/setUserPackages`,
            payload: { userPackages: selectPacket ? [packaged] : [] },
          });

          if (selectPacket?.name) {
            notification.success({
              description: dblFormatMessage("success_related"),
            });
          }
        }}
      />
    </>
  );
}
